import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { Button, Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
} from "@ant-design/icons";
import TenantApi from "../../common/Apis/TenantApi";
import CreateSubTenantModal from "../../Subtenants/CreateSubTenantModal";
import Pagination from "../../common/Pagination/Pagination";
import "../../common/Pagination/Pagination.css";

const SubTenantsUnderTenant = () => {
    const navigate = useNavigate();
    const { Content } = Layout;
    const { Panel } = Collapse;

    // ── Data ────────────────────────────────────────────────
    const [Tenants, setTenants] = React.useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // ── Pagination ──────────────────────────────────────────
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({ paginate: pageSize });

    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const [isCreateSubTenantModalVisible, setCreateSubTenantModalVisible] = useState(false);
    const [isUpdateSubTenantModalVisible, setUpdateSubTenantModalVisible] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const tenantId = new URLSearchParams(window.location.search).get("id");

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);
    }, []);

    // ── Fetch ───────────────────────────────────────────────
    const getTenants = useCallback(() => {
        TenantApi.TenantDetails(tenantId)
            .then((response) => {
                const list = response?.payload?.subTenantDTOList || [];
                setTenants(list);
                setTotalElements(list.length);
                setTotalPages(Math.ceil(list.length / pageSize));
                setCurrentPage(1);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [tenantId, pageSize]);

    useEffect(() => {
        getTenants();
        PageLoading();
    }, [getTenants, PageLoading]);

    // ── Modal handlers ──────────────────────────────────────
    const handleOpenCreateSubTenantModal = () => {
        setCreateSubTenantModalVisible(true);
    };

    const handleOpenUpdateSubTenantModal = (tenant) => {
        setSelectedTenant(tenant);
        setUpdateSubTenantModalVisible(true);
    };

    const handleCloseCreateSubTenantModal = () => {
        setCreateSubTenantModalVisible(false);
        getTenants();
    };

    const handleCloseUpdateSubTenantModal = () => {
        setUpdateSubTenantModalVisible(false);
        getTenants();
    };

    const navigateToUsersPage = (tenant) => {
        navigate(
            `/sub-tenants/${tenant.subTenantName.replace(/\s+/g, "-")}/users?id=${tenant.id}`
        );
    };

    const showDeleteModal = (tenant) => {
        setSelectedTenant(tenant);
        setDeleteModalVisible(true);
    };

    const closeDeleteModal = () => {
        setDeleteModalVisible(false);
        setSelectedTenant(null);
        getTenants();
    };

    // ── Pagination handlers ─────────────────────────────────
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({ paginate: value });
        setTotalPages(Math.ceil(Tenants.length / value));
    };

    // ── Filters ─────────────────────────────────────────────
    const formRef = useRef(null);
    const [filterTenant, setFilterTenants] = useState([
        { title: "", answerType: "", name: "" },
    ]);

    const handleAddfilterTenants = () => {
        setFilterTenants([
            ...filterTenant,
            { title: "", answerType: "", name: "" },
        ]);
    };

    const handleRemovefilterTenant = (FilterTenantIndex) => {
        const next = [...filterTenant];
        next.splice(FilterTenantIndex, 1);
        setFilterTenants(next);

        if (FilterTenantIndex === 0) {
            getTenants();
        }
    };

    const handleClear = () => {
        getTenants();
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);
        setFilterTenants([{ title: "", answerType: "", name: "" }]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);

        let singleLineString = filterTenant
            .filter((obj) => obj.title && obj.answerType && obj.name)   // ← skip empty rows
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=BETWEEN${createDateTimestamp(
                        obj.answerType
                    )}AND${createDateTimestamp(obj.name)}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
            "componentCode=SUB_TENANT&subTenant.id=" +
                decodedToken?.subTenantId +
                "&" +
                singleLineString
        );

        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, pageSize)
            .then((response) => {
                const filtered = response.payloadDto || [];
                setTenants(filtered);
                setTotalElements(filtered.length);
                setTotalPages(Math.ceil(filtered.length / pageSize));
                setCurrentPage(1);            // ← reset to first page
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createDateTimestamp = (Cdate) => {
        const date = new Date(Cdate);
        return Math.floor(date.getTime());
    };

    const handleChangeTitle = (i, value) => {
        const next = [...filterTenant];
        next[i].title = value;
        setFilterTenants(next);
    };
    const handleChangeAnswertype = (i, value) => {
        const next = [...filterTenant];
        next[i].answerType = value;
        setFilterTenants(next);
    };
    const handleChangename = (i, value) => {
        const next = [...filterTenant];
        next[i].name = value;
        setFilterTenants(next);
    };

    // ── Render ──────────────────────────────────────────────
    const paginatedData = Tenants.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const renderTableRows = () => {
        if (paginatedData.length === 0) {
            return (
                <tr className="text-center EmptyTable">
                    <td colSpan={2} className="text-center">
                        <img
                            src="/assest/Images/emptyIcon.svg"
                            className="logo-png mt-3"
                            style={{ width: "10%" }}
                            alt=""
                        />
                        <br />
                        No Data Available
                    </td>
                </tr>
            );
        }
        return paginatedData.map((item) => (
            <tr key={item.id} className="text-center">
                <td>{item.subTenantCode}</td>
                <td>{item.subTenantName}</td>
            </tr>
        ));
    };

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}

                <div style={{ padding: "20px", paddingBottom: "5px" }}>
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass "
                        onFinish={handleSubmit}
                    >
                        <Collapse>
                            <Panel
                                header={
                                    <h5 className="mb-0">
                                        <b>Filter</b>
                                    </h5>
                                }
                                key="1"
                            >
                                {filterTenant.map((input, filterTenantIndex) => (
                                    <div key={filterTenantIndex}>
                                        <Row gutter={12}>
                                            <Col span={5}>
                                                <Form.Item
                                                    name={`title${filterTenantIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please Select" }]}
                                                >
                                                    <Select
                                                        className="control-Select"
                                                        placeholder="Filter By"
                                                        value={input.title}
                                                        onChange={(value) =>
                                                            handleChangeTitle(filterTenantIndex, value)
                                                        }
                                                        options={[
                                                            { value: "subTenantCode", label: "Code" },
                                                            { value: "subTenantName", label: "Name" },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item
                                                    name={`type${filterTenantIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please Select type." }]}
                                                >
                                                    <Select
                                                        className="control-Select mb-1"
                                                        placeholder="Condition"
                                                        onChange={(value) =>
                                                            handleChangeAnswertype(filterTenantIndex, value)
                                                        }
                                                        options={[
                                                            { value: "%", label: "Matches with" },
                                                            { value: "=", label: "Equals to" },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={5}>
                                                <Form.Item
                                                    name={`name${filterTenantIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please enter Text." }]}
                                                >
                                                    <Input
                                                        type="text"
                                                        onChange={(e) =>
                                                            handleChangename(filterTenantIndex, e.target.value)
                                                        }
                                                        placeholder="Text"
                                                        className="control-input"
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={8}>
                                                <Form.Item className="text-lable">
                                                    {filterTenantIndex === 0 ? (
                                                        <Row gutter={23} className="mb-3">
                                                            <Col span={2} className="mx-0">
                                                                <Form.Item className="text-lable">
                                                                    <PlusCircleTwoTone
                                                                        onClick={handleAddfilterTenants}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Button
                                                                    type="primary"
                                                                    htmlType="submit"
                                                                    className="btn btn-primary btn-save table-action icon-center "
                                                                >
                                                                    Filter
                                                                </Button>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Button
                                                                    type="reset"
                                                                    htmlType="reset"
                                                                    onClick={() => handleClear()}
                                                                    style={{ color: "#0b5ed7" }}
                                                                    className="btn btn-primary btn-back table-action icon-center"
                                                                >
                                                                    Clear
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <MinusCircleTwoTone
                                                            onClick={() =>
                                                                handleRemovefilterTenant(filterTenantIndex)
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Panel>
                        </Collapse>
                    </Form>
                </div>

                <Content
                    className="form-content nav-content"
                    style={{ margin: "14px 16px 0", padding: "30px", background: "white" }}
                >
                    <div>
                        {/* Toolbar */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Button
                                type="primary"
                                style={{ padding: "5px 24px", fontSize: "18px" }}
                                onClick={() => handleOpenCreateSubTenantModal()}
                            >
                                Add New Store / Shop
                            </Button>

                            <Form form={formPaginate}>
                                <Form.Item
                                    name="paginate"
                                    className="text-lable"
                                    style={{ width: "100px", marginBottom: 0 }}
                                >
                                    <Select
                                        className="control-Select"
                                        onChange={(value) => handlePageSizeChange(value)}
                                        options={[
                                            { value: 10, label: "10" },
                                            { value: 20, label: "20" },
                                            { value: 30, label: "30" },
                                            { value: 40, label: "40" },
                                            { value: 50, label: "50" },
                                            { value: 100, label: "100" },
                                        ]}
                                    />
                                </Form.Item>
                            </Form>
                        </div>

                        <table className="table Tenants-table">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                        {paginatedData.length > 0 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                maxVisiblePages={5}
                                showPageInfo={true}
                                totalItems={totalElements}
                                pageSize={pageSize}
                            />
                        )}
                    </div>
                </Content>

                <CreateSubTenantModal
                    visible={isCreateSubTenantModalVisible}
                    onCancel={handleCloseCreateSubTenantModal}
                    tenantId={tenantId}
                />
            </Layout>
        </Layout>
    );
};

export default SubTenantsUnderTenant;